module.exports = __webpack_public_path__ + "static/img/环卫车.a20c257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/环卫车.jpg
// module id = MSu9
// module chunks = 1